import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import OpenableCardComponent, {
  IAttributes,
} from 'app/components/CustomBlocks/component/OpenableCardBlock/OpenableCardComponent'

const CardWithAuthorBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const [opened, setOpened] = React.useState<boolean>(false)
  const onToggle = React.useCallback(() => setOpened((val) => !val), [])

  return <OpenableCardComponent {...attributes} onToggle={onToggle} opened={opened} content={attributes.content} />
}

export default CardWithAuthorBlock
